import Image from 'next/image';

import styled from '../../theme/styled-with-theme';
import { mediaQueries } from '../../styles/media-queries';
import { pxToRem } from '../../styles/utils';

import { Flexbox } from '../Flexbox';
import { Text } from '../Text';
import { Column } from '../Layout';

export const Wrapper = styled(Flexbox)`
  flex-direction: column;
  margin: auto;
  width: 100%;
  ${mediaQueries.tablet} {
    flex-direction: row;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
  ${mediaQueries.desktop} {
    flex-wrap: nowrap;
    justify-content: space-between;
  }
`;

export const PlanColumn = styled(Column)`
  max-width: ${pxToRem(312)};

  ${mediaQueries.tablet} {
    max-width: unset;
  }
`;

export const PlanInfoWrapper = styled(Flexbox)`
  justify-content: space-between;
  flex-direction: column;
  align-items: center;
  margin-bottom: ${({ theme }) => theme.spacing.ml};
  padding: 0;
  border-radius: ${({ theme }) => theme.borderRadius.quickStartGuideBox};
  overflow: hidden;

  ${mediaQueries.tablet} {
    width: 30%;
    margin: ${({ theme }) => `0 ${theme.spacing.s}`};
    border-radius: ${({ theme }) => theme.borderRadius.planHeaderDesktop};
  }
`;

export const LogoWrapper = styled(Flexbox)<{ color: string }>`
  background-color: ${({ color }) => `#${color}`};
  width: 100%;
  align-items: center;
  justify-content: center;
  padding: ${({ theme }) => `${theme.spacing.l} 0 ${theme.spacing.ml}`};
  height: 110px;
`;

export const Logo = styled(Image)`
  max-width: 75%;
  height: 100%;
  align-items: center;
`;

export const TextWrapper = styled(Flexbox)`
  width: 100%;
  background-color: ${({ theme }) => theme.color.quickStartGuideToggle};
  padding: ${({ theme }) =>
    `${theme.spacing.ml} ${theme.spacing.ml} ${theme.spacing.l}`};
  flex-direction: column;
  justify-content: space-between;
  height: 100%;

  ${mediaQueries.desktop} {
    padding: ${({ theme }) =>
      `${theme.spacing.ml} ${theme.spacing.l} ${theme.spacing.xl}`};
  }
`;

export const ButtonWrapper = styled('div')`
  display: flex;
  margin-top: ${({ theme }) => theme.spacing.ml};

  a {
    margin: auto;
    width: 100%;
  }

  ${mediaQueries.tablet} {
    a {
      width: 80%;
    }
  }
`;

export const HeaderText = styled(Text)`
  margin-bottom: 10px;
  ${mediaQueries.tablet} {
    max-width: 160px;
  }
`;
